import React from "react";
import { connect } from "react-redux";

import { HistoryIndividual } from "./SubHistory";

import { getOrders, getMoreOrders, addLike, addDislike } from '../../actions/orderActions';
import { getHeader } from "../../helper";

class History extends React.Component {

    constructor() {
        super();

        this.handleMoreOrders = this.handleMoreOrders.bind(this);
    }

    componentWillMount() {
        const { dispatch, alien, userData } = this.props;
        let header = alien ? {} : getHeader();

        dispatch(getOrders({
            uri: "public_profile_contractor",
            bid_user_id: userData.id
        }, header));
    }

    handleMoreOrders(next) {
        if(!next) return false;
        const { dispatch, alien } = this.props;
        let headers = alien ? {} : getHeader();
        
        dispatch(getMoreOrders({
            params: {uriFull: next},
            headers
        }));
    }

    render() {
        const { orderList, session, alien, dispatch } = this.props;
        const { isFetchingMore, isFetching } = orderList;
        const moreOrders = orderList.data.next || null;

        return (
            <div>
                <div className="menu-content-history menu-content-item tab-parent screen-bottom-block">
                    <div className="rounded-white-block">

                        <div className="white-block-content">
                            <HistoryIndividual
                                session={session}
                                orderList={orderList}
                                handleLike={(item) => dispatch(addLike(item))}
                                handleDislike={(item) => dispatch(addDislike(item))}/>
                        </div>

                    </div>
                </div>
                {
                    moreOrders && !isFetching ?
                    <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                        <button
                            className={isFetchingMore ? 'disabled' : ''}
                            onClick={() => this.handleMoreOrders(moreOrders)}>{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button>
                    </div>
                    : ''
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(History);


// WEBPACK FOOTER //
// ./src/components/Profile/Portfolio.js